
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class AccountPayableService {
  constructor() {}

  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.cus_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_AP_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static updateVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method("updateVendorInvoice", input, responseCallBack, errorCallBack);
  }
  static createVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method("createVendorInvoice", input, responseCallBack, errorCallBack);
  }
  static getVendorInvoices(input, responseCallBack, errorCallBack) {
    this.method("getVendorInvoices", input, responseCallBack, errorCallBack);
  }
  static getVendorInvoiceLines(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorInvoiceLines",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method("readVendorInvoice", input, responseCallBack, errorCallBack);
  }
  static unLockVendorInvoiceCode(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockVendorInvoiceCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static lockVendorInvoiceCode(input, responseCallBack, errorCallBack) {
    this.method(
      "lockVendorInvoiceCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initVendorInvoiceModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initVendorInvoiceModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method("approveVendorInvoice", input, responseCallBack, errorCallBack);
  }
  static unApproveVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method(
      "unApproveVendorInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApproveVendorInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApproveVendorInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelVendorInvoice(input, responseCallBack, errorCallBack) {
    this.method("cancelVendorInvoice", input, responseCallBack, errorCallBack);
  }
  static createCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "createCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static voidedCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "voidedCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCheckTransactionPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCheckTransactionPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method("readCheckTransaction", input, responseCallBack, errorCallBack);
  }
  static printCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "printCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static rePrintCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "rePrintCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "approveCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initCheckTransactionModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initCheckTransactionModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockCheckTransactionNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockCheckTransactionNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getOpenCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "getOpenCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getOpenCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "getOpenCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static printBatchCheckTransaction(input, responseCallBack, errorCallBack) {
    this.method(
      "printBatchCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getBankAdjustmentPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getBankAdjustmentPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockBankAdjustmentNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockBankAdjustmentNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initBankAdjustmentModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initBankAdjustmentModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateBankAdjustment(input, responseCallBack, errorCallBack) {
    this.method("updateBankAdjustment", input, responseCallBack, errorCallBack);
  }
  static createBankAdjustment(input, responseCallBack, errorCallBack) {
    this.method("createBankAdjustment", input, responseCallBack, errorCallBack);
  }
  static approveBankAdjustment(input, responseCallBack, errorCallBack) {
    this.method(
      "approveBankAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveBankAdjustment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveBankAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveBankAdjustment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApproveBankAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCheckTransactionPaymentLinesForVendorInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCheckTransactionPaymentLinesForVendorInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveDeposit(input, responseCallBack, errorCallBack) {
    this.method("approveDeposit", input, responseCallBack, errorCallBack);
  }
  static getAccountReceivableDetailsForDeposit(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAccountReceivableDetailsForDeposit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateDeposit(input, responseCallBack, errorCallBack) {
    this.method("updateDeposit", input, responseCallBack, errorCallBack);
  }

  static createDeposit(input, responseCallBack, errorCallBack) {
    this.method("createDeposit", input, responseCallBack, errorCallBack);
  }
  static getDepositPageList(input, responseCallBack, errorCallBack) {
    this.method("getDepositPageList", input, responseCallBack, errorCallBack);
  }
  static initDepositModule(input, responseCallBack, errorCallBack) {
    this.method("initDepositModule", input, responseCallBack, errorCallBack);
  }
  static getLetterOfCreditPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getLetterOfCreditPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readLetterOfCredit(input, responseCallBack, errorCallBack) {
    this.method("readLetterOfCredit", input, responseCallBack, errorCallBack);
  }
  static createAndApproveDeposit(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApproveDeposit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockDepositNumber(input, responseCallBack, errorCallBack) {
    this.method("unLockDepositNumber", input, responseCallBack, errorCallBack);
  }
  static unLockLetterOfCreditNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockLetterOfCreditNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createLetterOfCredit(input, responseCallBack, errorCallBack) {
    this.method("createLetterOfCredit", input, responseCallBack, errorCallBack);
  }
  static updateLetterOfCredit(input, responseCallBack, errorCallBack) {
    this.method("updateLetterOfCredit", input, responseCallBack, errorCallBack);
  }
  static initLetterOfCreditModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initLetterOfCreditModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getVendorInvoicePaymentDetailsList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorInvoicePaymentDetailsList",
      input,
      responseCallBack,
      errorCallBack
    );
  }  

  static approveAndPrintCheckTransaction(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "approveAndPrintCheckTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.cus_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.cus_data_url,responseCallBack, errorCallBack);
    }
  }
}
